import React from 'react';
import Grid from "@mui/material/Grid2";
import {isClient, isExploitant} from "../../utils/roles";
import DashboardView from "./dashboard/DashboardView";
import DashboardViewV2 from "./dashboard/DashboardViewV2.js";
import DashboardClient from "./dashboard/DashboardClient.js";
import Constants from "../../utils/constants.js";
import DashboardMapView from "./dashboard/DashboardMapView.js";

const getInitialMode = () => {
    const value = window.localStorage.getItem("dashboard_view_mode");

    return [
        Constants.DASHBOARD_VIEW_MODE_OLD,
        Constants.DASHBOARD_VIEW_MODE_LIST,
        Constants.DASHBOARD_VIEW_MODE_MAP
    ].includes(value) ? value : Constants.DASHBOARD_VIEW_MODE_LIST;
}


const DashboardPage = () => {
    const [mode, setMode] = React.useState(getInitialMode());

    const changeMode = (mode) => {
        window.localStorage.setItem("dashboard_view_mode", mode);
        setMode(mode);
    }

    return (
        <>
            <Grid container>
                {isExploitant() &&
                    <Grid item size={12}>
                        {/*{mode === Constants.DASHBOARD_VIEW_MODE_OLD &&*/}
                        {/*    // NOT USED ANYMORE - DASHBOARD V1*/}
                        {/*    <DashboardView onModeChange={changeMode}/>*/}
                        {/*}*/}
                        {/*{mode === Constants.DASHBOARD_VIEW_MODE_LIST &&*/}
                        {/*    <DashboardViewV2 onModeChange={changeMode}/>*/}
                        {/*}*/}
                        {/*{mode === Constants.DASHBOARD_VIEW_MODE_MAP &&*/}
                        {/*    <DashboardMapView onModeChange={changeMode}/>*/}
                        {/*}*/}
                        <DashboardViewV2 />
                    </Grid>
                }
                {isClient() &&
                    <Grid item size={12}>
                        {mode === Constants.DASHBOARD_VIEW_MODE_LIST &&
                            <DashboardClient onModeChange={changeMode}/>
                        }
                    </Grid>
                }
            </Grid>
        </>
    )
}

export default DashboardPage;
